import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelCarbonReductionPlanId: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: { buildingModelCarbonReductionPlanId },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.carbonReductionPlanReports.error)
            throw new Error(data.carbonReductionPlanReports.error);
        else
            return data.carbonReductionPlanReports
                ?.cumulativeEmissionSavingsCard as CumulativeEmissionSavingsCardData;
    });

const query = graphql(`
    query buildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReport(
        $buildingModelCarbonReductionPlanId: Uuid!
    ) {
        carbonReductionPlanReports(buildingModelCarbonReductionPlanId: $buildingModelCarbonReductionPlanId) {
            error
            cumulativeEmissionSavingsCard {
                totalCarbonEmissionSavings
                totalCarbonEmissionSavingsFromMeasures
                totalCarbonEmissionSavingsFromGrid
            }
        }
    }
`);

export default queryFn;
